import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { ARGENTUS_CONTACT_INFO, MAX_UNITS_PER_CART_ITEM } from '@constants/constants';

/**
 * Aviso que aparece cuando el cliente llega al tope de unidades por producto.
 * Sobre ese tope el pedido se maneja como encargo personalizado, así que
 * ofrece las dos vías de contacto: el formulario de `/encargo` y WhatsApp.
 */
@Component({
  selector: 'app-max-units-notice',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './max-units-notice.component.html',
  styleUrl: './max-units-notice.component.css',
})
export class MaxUnitsNoticeComponent {
  /** Nombre del producto; se usa en el mensaje prellenado de WhatsApp. */
  public readonly productName = input<string>('');

  public readonly maxUnits = MAX_UNITS_PER_CART_ITEM;

  public readonly whatsappLink = computed(() => {
    const name = this.productName();
    const product = name ? `"${name}"` : 'un producto';
    const message = `Hola, quiero pedir más de ${this.maxUnits} unidades de ${product}.`;

    return `${ARGENTUS_CONTACT_INFO.WHATSAPP_URL}?text=${encodeURIComponent(message)}`;
  });
}
